export default {"src":"/_next/static/media/avatar-placeholder.44fb8fad.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};